import type { ScalesT } from '@mentimeter/question-modules-types';
import type { GuessTheNumberStaticContent } from '@core-api/presentation/types/response';
import { usePresentationContext } from '../../legacy-context/presentationContext';
import { NumericalQuestionPresentation } from './NumericalQuestionPresentation';

// We have the same type for controls, copy pasted for now
// Needs to be a type instead of interface as the interface can't satisfy the generic used with useSlideState hook
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type SlideStateNumericalQuestion = { showCorrect?: boolean };

type NumericalQuestionT = ScalesT;

export function NumericalQuestionPresentationDataHandler() {
  const {
    useQuestion,
    useResults,
    useSlideState,
    useConfig,
    InteractiveCanvasComponents,
  } = usePresentationContext();

  const slide = useQuestion();
  const { results = [] } = useResults<NumericalQuestionT>();
  const [{ showCorrect }] = useSlideState<SlideStateNumericalQuestion>();

  const { mode, enableAnimations } = useConfig();
  const shouldShowCorrect =
    showCorrect || mode === 'idle' || mode === 'screenshot';

  const interactiveContent = slide.interactiveContents[0]!;
  const staticContent = slide.staticContent as GuessTheNumberStaticContent;

  return (
    <NumericalQuestionPresentation
      title={slide.title}
      styledTitle={staticContent.styledTitle as Record<string, unknown>}
      label={staticContent.label}
      longerDescription={slide.interactiveContents[0]!.description}
      fontSizeOffset={staticContent.textSizeOffset}
      responseRange={{
        min: interactiveContent.responseRange?.min ?? 0,
        max: interactiveContent.responseRange?.max ?? 10,
      }}
      responseRangeScale={
        staticContent.interactiveContentStyling.responseRangeScale
      }
      correctAnswerRange={{
        min: interactiveContent.choices[0]!.correctAnswerRange?.min ?? 0,
        max: interactiveContent.choices[0]!.correctAnswerRange?.max ?? 1,
      }}
      results={results[0]?.score}
      shouldShowCorrect={shouldShowCorrect}
      CanvasVisualizationArea={
        InteractiveCanvasComponents?.CanvasVisualizationArea
      }
      shouldAnimate={enableAnimations}
      shouldHideResults={slide.responseVisibility === 'hidden'}
    />
  );
}
